import type { ConflictDetail } from "@/api/accounting/conflicts";

export interface DiffRow {
  field: string;
  domainValue: unknown;
  accountingValue: unknown;
  changed: boolean;
}

/**
 * Строки diff'а: сначала расхождения из diff[], затем остальные поля снапшотов
 * (они совпадают и по умолчанию скрыты).
 */
export function buildDiffRows(
  diff: ConflictDetail["diff"],
  domainSnapshot: Record<string, unknown> | null,
  accountingSnapshot: Record<string, unknown> | null,
): DiffRow[] {
  const changed = (diff || []).map((row) => ({ ...row, changed: true }));
  const seen = new Set(changed.map((row) => row.field));

  const rest = [
    ...Object.keys(domainSnapshot || {}),
    ...Object.keys(accountingSnapshot || {}),
  ]
    .filter((field) => {
      if (seen.has(field)) return false;
      seen.add(field);
      return true;
    })
    .map((field) => ({
      field,
      domainValue: domainSnapshot?.[field],
      accountingValue: accountingSnapshot?.[field],
      changed: false,
    }));

  return [...changed, ...rest];
}
